import { render, staticRenderFns } from "./CategoryTreeDraggable.vue?vue&type=template&id=0530bf58&scoped=true&"
import script from "./CategoryTreeDraggable.vue?vue&type=script&lang=js&"
export * from "./CategoryTreeDraggable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0530bf58",
  null
  
)

export default component.exports